export default __webpack_public_path__ + "706a90886f4d81be17127e650e6c82c0.webp";